module.exports = __webpack_public_path__ + "img/how_it_works_guestion_de_compra.b51331bb.svg";